<template>
  <!-- 我要发货 -->
  <div class="logistics-list">
    <ab-list-query>
      <template #right>
        <el-row :gutter="20">
          <el-col :span="4">
            <el-input
              placeholder="订单编号"
              v-model.trim="formSearch.custOrderNo"
              clearable
            >
            </el-input>
          </el-col>
          <el-col :span="4">
            <ab-select
              v-model="formSearch.supplierIdDesc"
              url="/bas/client/basSupplier/list"
              :urlData="{ name: formSearch.supplierIdDesc, pageNum: 1, pageSize: 10, isEnabled: 1 }"
              inputKey="nameOrNumber"
              descKey="name"
              placeholder="供应商"
              @handleSelect="supplierSelect"
            ></ab-select>
          </el-col>
          <el-col :span="4">
            <ab-select
              v-model="formSearch.customerName"
              url="/bas/client/basCustomer/list"
              :urlData="{ data: {}, name: formSearch.customerName, pageNum: 1, pageSize: 10, isEnabled: 1 }"
              inputKey="nameOrNumber"
              descKey="name"
              placeholder="客户"
              @handleSelect="customerSelect"
            ></ab-select>
          </el-col>
          <el-col :span="4">
            <el-select
              v-model="formSearch.bizType"
              placeholder="业务类型"
              clearable
              @change="searchForm"
            >
              <el-option label="代理进口" value="02" v-if="bizTypeNow == '01'"></el-option>
              <el-option label="合作进口" value="01" v-if="bizTypeNow == '01'"></el-option>
              <el-option label="代理出口" value="04" v-if="bizTypeNow == '02'"></el-option>
              <el-option label="合作出口" value="03" v-if="bizTypeNow == '02'"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <ab-timeSearch
              class="searchBox"
              startSrc="订单日期起"
              endSrc="订单日期止"
              v-model="formSearch.bizDateArray"
              @searchEvent="bizDateChange"
            ></ab-timeSearch>
          </el-col>
          <el-col
            :span="4"
            class="text-left"
          >
            <el-button @click="searchForm">搜索</el-button>
            <el-button
              link
              class="btn-svg"
              @click="resetForm"
            >
              <ab-svg name="qingchu"></ab-svg>清除
            </el-button>
          </el-col>
        </el-row>
      </template>

      <template #toolbar>
        <el-button
          type="primary"
          @click="newPage(null)"
          :disabled="!multiSelected.length"
        >批量发货</el-button>

        <el-button
          :loading="loading.export"
          @click="exportFile"
        >导出</el-button>
      </template>

      <template #table>
        <ab-table
          class="materialTable"
          ref="table"
          stripe
          showEdit
          showSelection
          selectionWidth="45"
          indexWidth="50"
          widths="140"
          isFilter="operator"
          :column-list="columns"
          :table-list="tableData"
          :dataListLoading="loading.table"
          :selectable="selectable"
          :handleSelectionChange="selectionChange"
          @filterColumns="filterColumns"
        >
          <template #operator="scope">
            <el-button
              type="primary"
              link
              @click="newPage(scope.row)"
            >发货</el-button>
          </template>
        </ab-table>
      </template>

      <template #page>
        <ab-page
          :pageTotal="page.total"
          :currentPage="page.currentPage"
          :pageSize="page.pageSize"
          :pageSizes="page.pageSizes"
          @searchForm="pageSearch"
        ></ab-page>
      </template>
    </ab-list-query>
  </div>
</template>

<script>
export default {
  name: 'delivery-notice',
  data() {
    return {
      routeQuery: {},
      loading: {
        table: false,
        export: false
      },
      formSearch: {},
      columns: [
        {
          props: 'custOrderNo',
          labels: '订单编号',
          widths: 150
        },
        {
          props: 'bizDate',
          labels: '订单日期',
          widths: 90
        },
        {
          props: 'supplierName',
          labels: '供应商',
          widths: 150
        },
        {
          props: 'customerName',
          labels: '客户',
          widths: 150
        },
        {
          props: 'bizTypeDesc',
          labels: '业务类型',
          widths: 100
        },
        {
          props: 'totalQty',
          labels: '订单数量 ',
          widths: 80
        },

        {
          props: 'totalDeliveredQty',
          labels: '已发数量',
          widths: 80
        },
        {
          props: 'canDeliveredQty',
          labels: '可发数量',
          widths: 80
        }
      ],
      //列表数据
      tableData: [],
      // 勾选行
      multiSelected: [],
      page: {
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        total: 0
      }
    }
  },
  computed: {
    bizTypeNow: {
        get() {
            return (
                this.$store.state.bizTypeNow 
            )
        }
    },
  },
  created() {
    
  },
  activated () {
    let query = this.$route.query || {}
    this.routeQuery = Object.keys(query).length ? query : this.routeQuery
    if (this.routeQuery.custOrderNo) {
      this.formSearch.custOrderNo = this.routeQuery.custOrderNo
    }
    this.searchForm()
  },

  methods: {
    // 供应商
    supplierSelect(row) {
      if (row && row.id) {
        this.formSearch.supplierId = row.id
      } else {
        this.formSearch.supplierId = ''
      }
      this.searchForm()
    },

    // 客户
    customerSelect(row) {
      if (row && row.id) {
        this.formSearch.customerId = row.id
      } else {
        this.formSearch.customerId = ''
      }
      this.searchForm()
    },
    
    // 订单日期
    bizDateChange(value) {
      if (value) {
        this.formSearch.bizDateBegin = value[0]
        this.formSearch.bizDateEnd = value[1]
      } else {
        this.formSearch.bizDateBegin = ''
        this.formSearch.bizDateEnd = ''
      }
      this.searchForm()
    },

    filterColumns(array) {
      this.columns = array
    },

    searchForm() {
      this.page.currentPage = 1
      this.getListData()
    },

    resetForm() {
      this.formSearch = {}
    },

    pageSearch(obj) {
      this.page.currentPage = obj.currentPage
      this.page.pageSize = obj.pageSize
      this.getListData()
    },

    getListData() {
      let params = Object.assign({}, this.formSearch, {
        storage: 1,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      })
      if (!params.bizType) {
            if (this.bizTypeNow == '01') {
                params.bizTypeList = ['01', '02', '11']
            } else if (this.bizTypeNow == '02') {
                params.bizTypeList = ['03', '04', '06']
            }
      } else if (params.bizType) {
        params.bizTypeList = [params.bizType]
      } else {
        params.bizTypeList = ['01', '02', '11']
      }
      this.$post('/tms/client/sendNotice/queryWaitPageList', params, this.loading, 'table').then(({ data }) => {
        if (data && data.code === 'C0000') {
          this.tableData = data.result.list
          this.page.total = data.result.total
        }
      })
    },

    selectable(row) {
      if (!this.multiSelected.length) {
        return true
      }
      const firstRow = this.multiSelected[0]
      // 委托方，受托方，业务类型，客户 必须一致
      return row.principalId === firstRow.principalId && row.trusteeId === firstRow.trusteeId && row.bizType === firstRow.bizType && row.customerId === firstRow.customerId
    },

    selectionChange(array) {
      this.multiSelected = array
    },

    newPage(row) {
      this.$router.push({
        path: '/logistics-detail',
        query: {
          action: 'add',
          list: JSON.stringify(row ? [ row ] : this.multiSelected)
        }
      })
    },

    // 导出
    exportFile() {
      const excelField = this.columns.map(e => e.props)
      let params = Object.assign({}, this.formSearch, { storage: 1, excelField: excelField })
      if (params.bizType) {
        params.bizTypeList = [params.bizType]
      } else if(this.bizTypeNow == '01') {
        params.bizTypeList = ['01', '02', '11']
      }else if(this.bizTypeNow == '02'){
        params.bizTypeList = ['03', '04', '06']
      }
      this.$post('/tms/client/sendNotice/queryWaitPageListExport', params, this.loading, 'export').then(({ data }) => {
        if (data && data.code === 'C0000') {
          // 创建隐藏的可下载链接
          var eleLink = document.createElement('a')
          eleLink.download = ''
          eleLink.style.display = 'none'
          // 字符内容转变成blob地址
          eleLink.href = data.message
          // 触发点击
          document.body.appendChild(eleLink)
          eleLink.click()
          // 然后移除
          document.body.removeChild(eleLink)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.logistics-list {
  .el-menu {
    display: none;
  }
  .el-table-fixed-column--right {
    .el-button + .el-button {
      position: relative;
      margin-left: 14px !important;
      &::before {
        content: '';
        position: absolute;
        left: -8px;
        top: 4px;
        width: 1px;
        height: 10px;
        background: #bfbfbf;
      }
    }
  }
}
</style>
